export default Object.freeze({
  clockIn: 'clockIn',
  clockOut: 'clockOut',
  mealBreakStart: 'mealBreakStart',
  mealBreakEnd: 'mealBreakEnd',
})
